// ToggleSwitch.js
import React from 'react';
import './ToggleSwitch.css';

const ToggleSwitch = ({ isOn, toggleSwitch }) => {
  return (
    <div className={`toggle-switch ${isOn ? 'on' : 'off'}`} onClick={toggleSwitch}>
      <div className="switch-handle"></div>
    </div>
  );
};

export default ToggleSwitch;
